import { useI18n } from "../i18n";
import { Trash2 } from "lucide-react";

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export const History = ({ sessions, onDelete }) => {
  const { t, date } = useI18n();
  return (
  <div className="grid gap-3 max-h-96 overflow-y-auto" data-testid="history-list">
    {sessions.length === 0 && <p className="text-subtle font-mono text-sm py-6">{t("emptyArchive")}</p>}
    {sessions.map((s) => (
      <div key={s.id} className="border border-line p-4 bg-elevated" data-testid={`history-item-${s.id}`}>
        <div className="flex justify-between items-start gap-4">
          <div>
            <p className="font-mono text-xs text-subtle">{date(s.created_at)} · {fmt(s.duration)} · {s.words.length} {t("wordsCount")}</p>
            <p className="font-mono text-amber tracking-wider mt-2 text-sm">{s.words.map((w) => w.word).join(" · ") || "—"}</p>
            <p className="text-sm text-muted mt-2 italic">{s.prediction}</p>
          </div>
          <button onClick={() => onDelete(s.id)} className="icon-btn" data-testid={`history-delete-${s.id}`}>
            <Trash2 size={14} />
          </button>
        </div>
      </div>
    ))}
  </div>
  );
};
